import {fromJson, URL_BASE_AUTH} from "../utils/helper.js";


class InspectionFrequencyComponent {


    constructor() {

        this.id = null;
        this.is_default = false;
        this.site_id = null;
        this.name = null;
        this.period_id = null;
        this.labor_rate_id = null;
        this.quantity_techs = null;
        this.quantity_hours = null;
        this.amount = null;
        this.month = null;
        this.year = null;
        this.service_ticket = null

    }


    static fromJson(object) {
        return fromJson((new InspectionFrequencyComponent()), object);
    }

}

export default InspectionFrequencyComponent;
